import { Injectable } from '@angular/core';

export interface AppConfig {
  apiUrl: string;
  authCheckEndpoint: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;

  /**
   * Load configuration from the config.json file at runtime.
   * This is called by APP_INITIALIZER before the app starts.
   */
  async loadConfig(): Promise<void> {
    try {
      const response = await fetch('/assets/config.json');
      if (!response.ok) {
        throw new Error(`Failed to load config: ${response.status}`);
      }
      this.config = await response.json();
    } catch (error) {
      console.error('Error loading configuration:', error);
      // Fallback to default values if config fails to load
      this.config = {
        apiUrl: 'https://localhost:7134',
        authCheckEndpoint: '/api/v1/wiki/auth-status'
      };
    }
  }

  get apiUrl(): string {
    return this.config?.apiUrl ?? 'https://localhost:7134';
  }

  get authCheckEndpoint(): string {
    return this.config?.authCheckEndpoint ?? '/api/v1/wiki/auth-status';
  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Configuration not loaded. Ensure ConfigService.loadConfig() is called before accessing config.');
    }
    return this.config;
  }
}
